import { createCustomEnum } from "./customEnum";

const DealNotesGeneralCategoriesTypes = createCustomEnum({
	Application: {
		name: "application",
		value: "application",
		displayName: "Application",
	},
	BankNotes: {
		name: "bank_notes",
		value: "bank_notes",
		displayName: "Bank Notes",
	},
	Other: {
		name: "other",
		value: "other",
		displayName: "Other",
	},
});

export default DealNotesGeneralCategoriesTypes;
